import BlurFade from '#app/components/magicui/blur-fade.tsx'
import { DATA } from '#app/data/portfolio.tsx'
import { ProjectCard } from '#app/features/portfolio/components/project-card.tsx'

const BLUR_FADE_DELAY = 0.04

// Projects = things with a buy link (see the note above `DATA.projects`). Everything
// without one — demos, essays — lives in the Writing section instead.
const Projects = () => {
	return (
		<section id="projects" className="container">
			<div className="flex min-h-0 flex-col gap-y-3">
				<BlurFade delay={BLUR_FADE_DELAY * 5}>
					<h2 className="text-xl font-bold">Projects</h2>
				</BlurFade>
				<div className="mx-auto grid grid-cols-1 gap-6">
					{DATA.projects.map((project, id) => (
						<BlurFade
							key={project.title}
							delay={BLUR_FADE_DELAY * 6 + id * 0.05}
						>
							<ProjectCard
								href={project.href}
								key={project.title}
								title={project.title}
								eyebrow={project.eyebrow}
								description={project.description}
								dates={project.dates}
								tags={project.technologies}
								video={project.video}
								links={project.links}
							/>
						</BlurFade>
					))}
				</div>
			</div>
		</section>
	)
}

export default Projects
